<template>
  <v-flex>
    <v-col style="width: 100%" wrap>
      <v-list
        class="pt-0"
        dense
      >
        <v-list-item
          v-for="(dgd,index) in driverGroup.driverGroupDrivers"
          :key="dgd.id"
        > 
          <v-flex md3>
          <v-text>{{ dgd.driver.id }}</v-text>
        </v-flex>
        <v-flex md3>
          <v-text>{{ dgd.driver.user.name }}</v-text>
        </v-flex>
        <v-flex md3>
          <v-text>{{ dgd.driver.callsign }}</v-text>
        </v-flex>
        <v-flex md3>
          <v-btn @click="removeDriver(dgd.driver.id, index)" small>Remove</v-btn>
        </v-flex>
        </v-list-item>
      </v-list>
      <v-flex mt-5>
        <SelectableDriverUserInput
          :driver="driver"
          :user="user"
          @update="handleUpdate"
          label="Enter id or name"
        />
      <v-flex pt-3></v-flex><v-btn @click="addDriver" small>Add Driver</v-btn></v-flex>
    </v-col>
  </v-flex>
</template>

<script>

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;


import SelectableDriverUserInput from "@/components/widget/input/SelectableDriverUserDropdownInputForNoMatch.vue";


export default {
  name: "driver_group_form",
  components: {
    SelectableDriverUserInput
  },
  props: {
    driverGroup: Object
  },
  data: function() {
    return {
      addDriverId: null,
    };
  },
  mounted: function() {
  },
  methods: {
    addDriver() {

      let url = `${this.$store.state.apiUrl}/driver_group/${this.driverGroup.id}/addDriverToGroup?driverId=${this.addDriverId}`;

      let self = this;

      axios({
        url: url,
        method: "post",
        data: {},
      }).then(function(response) {
        console.log(response.data.errors);

        self.driverGroup.driverGroupDrivers.push(response.data)


      }).catch(function(error) {
      
      });
    },
    removeDriver(driverId, index) {

      let url = `${this.$store.state.apiUrl}/driver_group/removeDriverFromGroup?driverId=${driverId}`;

      let self = this;

      axios({
        url: url,
        method: "post",
        data: {},
        headers: {
          'Content-Type': 'text/plain'
        }
      }).then(function(response) {
        console.log(response.data.errors)

        self.driverGroup.driverGroupDrivers.splice(index,1);        

      }).catch(function(error) {
      
      });
    },
    handleUpdate(id) {
      console.log("Driver selected " + id);
      this.addDriverId = id;
    },
    errorForField: function(field) {
      try {
        return this.errors[field];
      } catch (err) {
        return null;
      }
    },
    resetError: function(field) {
      try {
        if (this.errors[field] != "") {
          this.errors[field] = "";
        }
      } catch (err) {}
    },
    validateForm: function() {
      this.$refs.loyaltyTierForm.validate();
    }
  },
  watch: {
    valid: function() {
      this.$emit("validityChange", this.valid);
    }
  }
};
</script>

<style>
.noStepNumber input[type="number"] {
  -moz-appearance: textfield;
}
.noStepNumber input::-webkit-outer-spin-button,
.noStepNumber input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>